import React from 'react'
import { Link } from 'react-router-dom'
import ContactCard from './ContactCard'

const ContactList = (props) => {

    const deleteContact = (id) => {
        props.onDelete(id)
    }

    const contactList = props.contacts.map((contact) => {
        return (
            <ContactCard contact={contact} clickHandler={deleteContact} key={contact.id} />
        )
    })
    return (
        <div className="main">
            <h2 style={{ marginTop: "50px" }}>Contact List</h2>
            <Link to="/add">
                <button className="ui button blue right">Add Contact</button>
            </Link>
            <div className="ui celled list">{contactList}</div>
        </div>
    )
}

export default ContactList




// WEBPACK FOOTER //
// ./src/components/ContactList.js